class AdicionarUsuario {
    static get $inject() {
        return ['api', '$scope', 'promiseTracker', 'cepService', 'cidadeService']
    }

    constructor(api, scope, promiseTracker, cepService, cidadeService) {
        this.api = api
        this.cepService = cepService
        this.cidadeService = cidadeService
        this.apply = (fun) => scope.$apply(fun)

        this.submitTracker = promiseTracker()
    }

    $onInit() {
        this.dadosUsuario = { cpf: this.resolve.cpf }
        this.erros = {}
    }

    validateConfirmation(input) {
        if (this.dadosUsuario.password !== this.dadosUsuario.password_confirmation) {
            return input.$setValidity('confirmation', false)
        } else {
            return input.$setValidity('confirmation', true)
        }
    }

    adicionar() {
        if (this.form.$valid) {
            let dados = angular.copy(this.dadosUsuario)
            dados.numero = `${dados.numero}`
            dados.cep = dados.cep.replace('-', '')
            
            this.submitTracker.addPromise(
                this.api.post("/usuarios", { usuario: dados, empresa_id: this.resolve.contratoId })
                    .then(() => {
                        Alert.success("Solicite ao novo usuário que verifique seu email para concluir o cadastro.", "Pré-cadastro realizado")
                        this.close(new Retorno(true))
                    })
                    .catch(({ status, data }) => {
                        if (status === 422) {
                            const result = []

                            for (var { field, error } of Array.from(data.errors)) {
                                this.form[field].$setValidity(error, false)
                                result.push(this.form[field].$viewChangeListeners.push(() => this.form[field].$setValidity(error, true)))
                            }

                            return result
                        } else {
                            Alert.error("Um erro ocorreu ao realizar o cadastro deste usuário", "Usuário não foi cadastrado")
                        }
                    })
            )
        }
    }

    buscarCep() {
        if (this.dadosUsuario.cep && (this.dadosUsuario.cep.length === 9)) {
            this.erros.cep = null
            const cep = this.dadosUsuario.cep

            return this.cepService.buscarCep(cep, result => {
                if (result.success && result.data) {
                    this.dadosUsuario.bairro = result.data.bairro
                    this.dadosUsuario.endereco = result.data.logradouro

                    this.cidadeService.search({ codigo_ibge: result.data.ibge }, data => {
                        this.listOfCidade = data
                        if (data.length > 0) {
                            return this.dadosUsuario.cidade_id = data[0].id
                        }
                    })
                    this.dadosUsuario.ibge = result.data.ibge

                    return $('[name="numero"]').focus()
                } else {
                    return this.erros.cep = 'CEP inválido'
                }
            })
        }
    }

    refreshCidade(search) {
        this.cidadeService.search({ nome: search }, data => {
            return this.listOfCidade = data
        })
    }
}

angular.module("eficienciaFiscalModule")
    .component("adicionarUsuario", {
        controller: AdicionarUsuario,
        bindings: {
            close: '&',
            resolve: '<'
        },
        template: `
        <form ng-submit="$ctrl.adicionar()" name="$ctrl.form" novalidate>
            <modal modal-title="Adicionar usuário" close="$ctrl.close">
                <modal-body>
                    <div class="clearfix">                    
                        <div class="row">
                            <div class="form-group col-xs-3">
                                <label for="cpf">CPF</label>
                                <input
                                    type="text"
                                    ng-model="$ctrl.dadosUsuario.cpf"
                                    placeholder="000.000.000-00"
                                    name="cpf"
                                    ui-br-cpf-mask="ui-br-cpf-mask"
                                    required
                                    class="form-control"/>
                                <div
                                    ng-messages="$ctrl.form.cpf.$error"
                                    ng-messages-multiple="ng-messages-multiple"
                                    ng-messages-include="erros-validacao"
                                    ng-if="$ctrl.form.$submitted">
                                    <span ng-message="cpf" class="help-block txt-color-red font-xs no-margin">
                                        CPF inválido
                                    </span>
                                    <span ng-message="already_exists" class="help-block txt-color-red font-xs no-margin">
                                        CPF já cadastrado
                                    </span>
                                </div>
                            </div>
                            <div class="form-group col-xs-9">
                                <label for="email">E-mail</label>
                                <input
                                    type="email"
                                    ng-model="$ctrl.dadosUsuario.email"
                                    placeholder="meunome@email.com"
                                    name="email"
                                    required
                                    class="form-control"/>
                                <div
                                    ng-messages="$ctrl.form.email.$error"
                                    ng-messages-multiple="ng-messages-multiple"
                                    ng-messages-include="erros-validacao"
                                    ng-if="$ctrl.form.$submitted">
                                    <span ng-message="email" class="help-block txt-color-red font-xs no-margin">
                                        E-mail inválido
                                    </span>
                                    <span ng-message="already_exists" class="help-block txt-color-red font-xs no-margin">
                                        E-mail já cadastrado
                                    </span>
                                </div>
                            </div>
                            <div class="form-group col-xs-12">
                                <label for="nome">
                                    Nome Completo 
                                    <i
                                        ng-click="$ctrl.dadosUsuario.nome = ''"
                                        ng-if="$ctrl.dadosUsuario.nome"
                                        class="fa fa-trash-o text-danger cursor-pointer">
                                    </i>
                                </label>
                                <input
                                    name="nome"
                                    ng-model="$ctrl.dadosUsuario.nome"
                                    class="form-control"
                                    required/>
                                <div
                                    ng-messages="$ctrl.form.nome.$error"
                                    ng-messages-multiple="ng-messages-multiple"
                                    ng-messages-include="erros-validacao"
                                    ng-if="$ctrl.form.$submitted">
                                </div>
                            </div>
                            <div class="form-group col-xs-6">
                                <label for="password">
                                    Senha do novo usuário 
                                    <i
                                        ng-click="$ctrl.dadosUsuario.password = ''"
                                        ng-if="$ctrl.dadosUsuario.password"
                                        class="fa fa-trash-o text-danger cursor-pointer">
                                    </i>
                                </label>
                                <input
                                    name="password"
                                    ng-model="$ctrl.dadosUsuario.password"
                                    class="form-control"
                                    type="password"
                                    required/>
                                <div
                                    ng-messages="$ctrl.form.password.$error"
                                    ng-messages-multiple="ng-messages-multiple"
                                    ng-messages-include="erros-validacao"
                                    ng-if="$ctrl.form.$submitted">
                                </div>
                            </div>
                            <div class="form-group col-xs-6">
                                <label for="password_confirmation">
                                    Confirmar senha 
                                    <i
                                        ng-click="$ctrl.dadosUsuario.password_confirmation = ''"
                                        ng-if="$ctrl.dadosUsuario.password_confirmation"
                                        class="fa fa-trash-o text-danger cursor-pointer">
                                    </i>
                                </label>
                                <input
                                    name="password_confirmation"
                                    ng-model="$ctrl.dadosUsuario.password_confirmation"
                                    class="form-control"
                                    type="password"
                                    required
                                    ng-change="$ctrl.validateConfirmation($ctrl.form.password_confirmation)"/>
                                <div
                                    ng-messages="$ctrl.form.password_confirmation.$error"
                                    ng-messages-multiple="ng-messages-multiple"
                                    ng-messages-include="erros-validacao"
                                    ng-if="$ctrl.form.$submitted">
                                    <span ng-message="confirmation" class="help-block txt-color-red font-xs no-margin">
                                        Senhas são diferentes
                                    </span>
                                </div>
                            </div>
                        </div>
                        <hr/>
                        <div class="row">
                            <div class="form-group col-xs-2">
                                <label for="cep">
                                    CEP
                                    <i
                                        ng-click="$ctrl.dadosUsuario.cep = ''"
                                        ng-if="$ctrl.dadosUsuario.cep"
                                        class="fa fa-trash-o text-danger cursor-pointer">
                                    </i>
                                </label>
                                <input
                                    name="cep"
                                    ng-model="$ctrl.dadosUsuario.cep"
                                    class="form-control"
                                    required
                                    ui-mask="99999-999"
                                    ui-mask-return="false"
                                    ng-change="$ctrl.buscarCep()"
                                    autofocus="autofocus"/>
                                <div
                                    ng-messages="$ctrl.form.cep.$error"
                                    ng-messages-multiple="ng-messages-multiple"
                                    ng-messages-include="erros-validacao"
                                    ng-if="$ctrl.form.$submitted">
                                </div>
                                <small class="text-danger fade-animation">{{$ctrl.erros.cep}}</small>
                            </div>
                            <div style="display:none" ng-show="$ctrl.dadosUsuario.cep" class="form-group col-xs-8 fade-animation">
                                <label for="rua">
                                    Endereço
                                    <i
                                        ng-click="$ctrl.dadosUsuario.endereco = ''"
                                        ng-if="$ctrl.dadosUsuario.endereco"
                                        class="fa fa-trash-o text-danger cursor-pointer">
                                    </i>
                                </label>
                                <input
                                    name="rua"
                                    ng-model="$ctrl.dadosUsuario.endereco"
                                    class="form-control"
                                    required/>
                                <div
                                    ng-messages="$ctrl.form.rua.$error"
                                    ng-messages-multiple="ng-messages-multiple"
                                    ng-messages-include="erros-validacao"
                                    ng-if="$ctrl.form.$submitted">
                                </div>
                            </div>
                            <div style="display:none" ng-show="$ctrl.dadosUsuario.cep" class="form-group col-xs-2 fade-animation">
                                <label>
                                    Número
                                    <i
                                        ng-click="$ctrl.dadosUsuario.numero = ''"
                                        ng-if="$ctrl.dadosUsuario.numero"
                                        class="fa fa-trash-o text-danger cursor-pointer">
                                    </i>
                                </label>
                                <input
                                    name="numero"
                                    ng-model="$ctrl.dadosUsuario.numero"
                                    class="form-control"
                                    required/>
                                <div
                                    ng-messages="$ctrl.form.numero.$error"
                                    ng-messages-multiple="ng-messages-multiple"
                                    ng-messages-include="erros-validacao"
                                    ng-if="$ctrl.form.$submitted">
                                </div>
                            </div>
                            <div style="display:none" ng-show="$ctrl.dadosUsuario.cep" class="form-group col-xs-6 fade-animation">
                                <label for="bairro">
                                    Bairro
                                    <i
                                        ng-click="$ctrl.dadosUsuario.bairro = ''"
                                        ng-if="$ctrl.dadosUsuario.bairro"
                                        class="fa fa-trash-o text-danger cursor-pointer">
                                    </i>
                                </label>
                                <input
                                    name="bairro"
                                    ng-model="$ctrl.dadosUsuario.bairro"
                                    class="form-control"
                                    required/>
                                <div
                                    ng-messages="$ctrl.form.bairro.$error"
                                    ng-messages-multiple="ng-messages-multiple"
                                    ng-messages-include="erros-validacao"
                                    ng-if="$ctrl.form.$submitted">
                                </div>
                            </div>
                            <div style="display:none" ng-show="$ctrl.dadosUsuario.cep" class="form-group col-xs-6 fade-animation">
                                <label>
                                    Cidade
                                    <i
                                        ng-click="$ctrl.dadosUsuario.cidade_id = undefined"
                                        ng-if="$ctrl.dadosUsuario.cidade_id"
                                        title="Click aqui para limpar este campo."
                                        class="fa fa-trash-o text-danger cursor-pointer">
                                    </i>
                                </label>
                                <ui-select
                                    allow-clear="allow-clear"
                                    theme="bootstrap"
                                    name="cidade"
                                    reset-search-input="false"
                                    ng-model="$ctrl.dadosUsuario.cidade_id"
                                    style="width:100%"
                                    ng-required="true"
                                    on-select="undefined($item, $model)">
                                    <ui-select-match placeholder="Digite para buscar uma cidade">
                                        {{$select.selected.nome}}
                                    </ui-select-match>
                                    <ui-select-choices
                                        repeat="cidade.id as cidade in $ctrl.listOfCidade | filter: $select.search track by cidade.id"
                                        refresh="$ctrl.refreshCidade($select.search)"
                                        refresh-delay="500">
                                        <div ng-bind-html="(cidade.nome + ' - ' + cidade.estado.sigla) | highlight: $select.search"></div>
                                    </ui-select-choices>
                                </ui-select>
                                <div
                                    ng-messages="$ctrl.form.cidade.$error"
                                    ng-messages-multiple="ng-messages-multiple"
                                    ng-messages-include="erros-validacao"
                                    ng-if="$ctrl.form.$submitted">
                                </div>
                            </div>
                        </div>
                    </div>
                </modal-body>
                <modal-footer>
                    <button type="submit" ng-disabled="$ctrl.submitTracker.active()" class="btn btn-primary">
                        <span ng-hide="$ctrl.submitTracker.active()">
                            <i class='fa fa-plus'></i> Adicionar
                        </span>
                        <span ng-show="$ctrl.submitTracker.active()">
                            <i class="fa fa-circle-o-notch fa-spin"></i> Adicionando...
                        </span>
                    </button>
                    <button type="button" ng-click="$ctrl.close()" class="btn btn-default">Fechar</button>
                </modal-footer>
            </modal>
        </form>
        `
    })
